/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Ad_TemplateInputs */

const en_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create AD Template`)
};

const fr_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un modèle AD`)
};

const de_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage erstellen`)
};

const it_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea modello di annuncio`)
};

const ru_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать шаблон объявления`)
};

const es_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear plantilla de AD`)
};

const zh_cn2_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 AD 模板`)
};

const ja_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADテンプレートを作成する`)
};

const hi_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्पलेट बनाएं`)
};

const pt_pt2_create_ad_template = /** @type {(inputs: Create_Ad_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar modelo de anúncio`)
};

/**
* | output |
* | --- |
* | "Create AD Template" |
*
* @param {Create_Ad_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_ad_template = /** @type {((inputs?: Create_Ad_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Ad_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_create_ad_template(inputs)
	if (locale === "de") return de_create_ad_template(inputs)
	if (locale === "it") return it_create_ad_template(inputs)
	if (locale === "ru") return ru_create_ad_template(inputs)
	if (locale === "es") return es_create_ad_template(inputs)
	if (locale === "zh-CN") return zh_cn2_create_ad_template(inputs)
	if (locale === "ja") return ja_create_ad_template(inputs)
	if (locale === "hi") return hi_create_ad_template(inputs)
	if (locale === "pt-PT") return pt_pt2_create_ad_template(inputs)
	return en_create_ad_template(inputs)
});